import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from './../../../../shared/Components/base/base.component';
import { PagingService } from './../../../../shared/Services/PagingService';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ServiceTypeService } from '../../services/serviceTypeService';
import { AddServiceTypeComponent } from '../add-service-type/add-service-type.component';
import { UpdateServiceTypeComponent } from '../update-service-type/update-service-type.component';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'ngx-service-types',
  templateUrl: './service-type.component.html',
  styleUrls: ['./service-type.component.scss'],
})
export class ServiceTypeComponent extends BaseComponent implements OnInit {
  constructor(
    public service: ServiceTypeService,
    public route: Router,
    public paging: PagingService,
    private diag: NbDialogService,
    private toast: NbToastrService,
  ) {
    super(route, service, paging, '');
  }

  ngOnInit() {
    this.loadEntities();
  }

  add() {
    this.diag.open(AddServiceTypeComponent).onClose.subscribe((res) => {
      if (res === 'true') this.loadEntities();
    });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }
  
  update(serviceRate) {
    const copymodel = {...serviceRate}
    this.diag.open(UpdateServiceTypeComponent, { context: { sType: copymodel } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.loadEntities();
      }
    });
  }
}
